<template>
  <section class="p-2">
    <v-card>
      <v-card-title class="d-flex justify-space-between p-0 m-0">
        <div class="ps-2 headingFontsize">Create Deposit Channel</div>
        <div>
          <bread-crumb
            :bread-crumbs="['Deposit Channel', 'Create Deposit Channel']"
          />
        </div>
      </v-card-title>
      <v-divider class="p-0 m-0 primary--text"></v-divider>
      <!-- <v-row class="mt-2 ms-1 me-1">
        <v-col cols="12" md="6">
          <h3 class="labelFontsize  mb-0 mt-2 mb-4">Deposit Channel</h3>
        </v-col>
      </v-row> -->
      <v-form ref="Addform" v-model="valid">
        <v-row class="mt-2 ms-1 me-1">
          <v-col cols="12" md="3">
            <label class="labelFontsize mb-0 required">Channel Name</label>
            <v-text-field
              v-model="depositeData.name"
              outlined
              dense
              class="rounded"
              :rules="FieldRequired('Channel name')"
              placeholder="Channel Name"
            >
            </v-text-field>
          </v-col>
          <v-col cols="12" md="3">
            <label class="labelFontsize mb-0 required">Country</label>
            <v-autocomplete
              v-model="depositeData.country"
              outlined
              dense
              class="rounded"
              item-text="txt"
              item-value="val"
              :disabled="isupdate_mode"
              :items="countryOptions"
              placeholder="Country"
              :rules="FieldRequired('Country')"
              @input="getallLedgersByCountry()"
            >
            </v-autocomplete>
          </v-col>
          <v-col cols="12" md="3">
            <label class="labelFontsize mb-0">Currency Type</label>
            <v-text-field
              v-model="depositeData.currency"
              outlined
              dense
              disabled
              class="rounded"
              placeholder="Currency Type"
            >
            </v-text-field>
          </v-col>
          <v-col cols="12" md="3">
            <label class="labelFontsize mb-0">Channel Type</label>
            <v-autocomplete
              v-model="depositeData.channel_type"
              outlined
              dense
              class="rounded"
              item-text="txt"
              :disabled="isupdate_mode"
              item-value="val"
              :items="channelTypes"
              placeholder="Account Type"
            >
            </v-autocomplete>
          </v-col>
        </v-row>
        <v-row class="mt-2 ms-1 me-1">
          <v-col cols="12" md="3">
            <label class="labelFontsize mb-0 required">Mapped Ledger ID</label>
            <v-autocomplete
              v-model="depositeData.ledger_id"
              outlined
              dense
              class="rounded"
              :disabled="isupdate_mode"
              item-text="name"
              item-value="ledger_id"
              :items="ledgerIds"
              :rules="FieldRequired('Mapped Ledger ID')"
              placeholder="Mapped Ledger ID"
            >
            </v-autocomplete>
          </v-col>
          <v-col cols="12" md="3">
            <label class="labelFontsize mb-0">External Id</label>
            <v-text-field
              v-model="depositeData.external_id"
              outlined
              :disabled="isupdate_mode"
              dense
              class="rounded"
              placeholder="External ID"
            >
            </v-text-field>
          </v-col>
          <v-col cols="12" md="3">
            <label class="labelFontsize mb-0">Account No</label>
            <v-text-field
              v-model="depositeData.account_number"
              outlined
              :disabled="isupdate_mode"
              dense
              class="rounded"
              placeholder="Account No"
            >
            </v-text-field>
          </v-col>
          <v-col cols="12" md="3">
            <label class="labelFontsize mb-0">Account Type</label>
            <v-autocomplete
              v-model="depositeData.account_type"
              outlined
              :disabled="isupdate_mode"
              dense
              class="rounded"
              item-text="txt"
              item-value="val"
              :items="accountTypes"
              placeholder="Account Type"
            >
            </v-autocomplete>
          </v-col>
        </v-row>
        <v-row class="mt-2 ms-1 me-1">
          <v-col cols="12" md="3">
            <label class="labelFontsize mb-0">Account Name</label>
            <v-text-field
              v-model="depositeData.account_name"
              outlined
              :disabled="isupdate_mode"
              dense
              class="rounded"
              placeholder="Account Name"
            >
            </v-text-field>
          </v-col>
          <v-col cols="12" md="3">
            <label class="labelFontsize mb-0">Account Other Name </label>
            <v-text-field
              v-model="depositeData.account_other_name"
              :disabled="isupdate_mode"
              outlined
              dense
              class="rounded"
              placeholder="Account Name Other"
            >
            </v-text-field>
          </v-col>
          <v-col cols="12" md="3">
            <v-switch
              v-model="depositeData.is_active"
              :disabled="isupdate_mode"
              label="Active"
              color="green"
              hide-details
            ></v-switch>
          </v-col>
          <v-col cols="12" md="3">
            <label class="labelFontsize mb-0">Bank logo</label>
            <v-file-input
              v-model="imageData.banklogo"
              accept="image/png, image/jpeg, image/bmp, image/bmp"
              placeholder="Upload Bank Logo"
              dense
              outlined
              prepend-icon=""
              ref="bankLogo"
              class="rounded"
              @change="
                genrateURL('bankLogourl', imageData.banklogo, 'bank_logo')
              "
            >
              <template v-slot:append>
                <v-btn depressed x-small icon @click="openIdlast">
                  <v-icon aria-hidden="false" color="primary">
                    mdi-cloud-upload
                  </v-icon>
                </v-btn>
              </template>
              <template v-slot:append-outer>
                <v-img
                  v-if="imageData.bankLogourl"
                  class="mt-0 pa-0"
                  max-height="40"
                  max-width="50"
                  :src="imageData.bankLogourl"
                  @click="handleImageViewer(imageData.bankLogourl)"
                />
              </template>
            </v-file-input>
          </v-col>
        </v-row>

        <v-row class="mt-2 ms-1 me-1 mb-5">
          <v-row justify="end" class="mb-5 me-5 mt-2">
            <v-btn
              depressed
              small
              color="primary"
              outlined
              class="me-2"
              @click="$router.push('/depositChannel')"
              >Cancel</v-btn
            >
            <v-btn depressed small color="primary" @click="submitData()"
              ><v-icon small>mdi-content-save-plus-outline</v-icon>Save</v-btn
            >
          </v-row>
        </v-row>
      </v-form>
    </v-card>
    <image-viewer
      :showDialog="isImageViewer"
      :picture="{
        PicHeight: '350',
        PicWidth: 600,
        Pic: imageViewerUrl,
      }"
      @closeImageViewer="handleCloseImageViewer"
    ></image-viewer>
    <OverlayPageVue :showOverlay="loader" />
  </section>
</template>
<script>
import OverlayPageVue from "@/utils/OverlayPage.vue";
import BreadCrumb from "@/components/navigations/BreadCrumb.vue";
import setupService from "@/services/SetupService/setupService.js";
import commonService from "@/services/CommonService/commonService.js";
import alerts from "@/mixins/alerts";
import { FieldRequired } from "@/utils/validation.js";
import { filterNumberInput } from "@/utils/contactNumber/formatNumber.js";
import imageViewer from "@/components/tools/imageViewer.vue";
export default {
  name: "Create Deposit Channel",
  mixins: [alerts],
  data: () => {
    return {
      FieldRequired,
      filterNumberInput,
      isImageViewer: false,
      isupdate_mode: false,
      imageViewerUrl: "",
      loader: false,
      valid: true,
      channelId: null,
      countryOptions: [],
      channelTypes: [],
      ledgerIds: [],
      accountTypes: [],
      fileRules: [],
      dropdown: {
        country_objs: [],
      },
      depositeData: {
        name: "",
        country: "",
        currency: "",
        channel_type: "TX",
        ledger_id: 0,
        external_id: "",
        account_number: "",
        account_type: "M",
        account_name: "",
        account_other_name: "",
        bank_logo: [],
        is_active: true,
      },
      imageData: {
        banklogo: [],
        bankLogourl: null,
      },
    };
  },

  components: {
    BreadCrumb,
    imageViewer,
    OverlayPageVue,
  },

  watch: {
    "depositeData.country"(val) {
      this.dropdown.country_objs.map((ele) => {
        if (ele.iso_alpha3 === val) {
          this.depositeData.currency = ele.currency_code;
        }
      });
    },
  },

  mounted() {
    this.getcountryList();
    this.getchannelTypes();
    this.getchannelAccTypes();
    if (this.$route.query.id) {
      this.channelId = this.$route.query.id;
      this.getChannelById(this.channelId);
      this.isupdate_mode = true;
    }
  },

  methods: {
    stoploader() {
      setTimeout(() => {
        this.loader = false;
      }, 400);
    },

    openIdlast() {
      this.$refs.bankLogo.$el.querySelector("input").click();
    },
    genrateURL(keyField, value, assignKey) {
      if (!keyField) return;
      if (!value) {
        this.imageData[`${keyField}`] = null;
        this.depositeData[`${assignKey}`] = null;
      } else {
        this.imageData[`${keyField}`] = URL.createObjectURL(value);
        this.depositeData[`${assignKey}`] = value;
      }
    },
    handleFileUpload(data) {
      console.log("image data", data);
      if (data) {
        this.depositeData.bank_logo.value = URL.createObjectURL(data);
        console.log(this.depositeData.bank_logo.value);
      } else {
        this.depositeData.bank_logo.value = null;
      }
      if (data.type.startsWith("image/")) {
        this.fileRules = [];
      } else {
        this.fileRules.push("Invalid image type.");
      }
    },

    handleCloseImageViewer() {
      this.isImageViewer = !this.isImageViewer;
      this.imageViewerUrl = "";
    },

    handleImageViewer(url) {
      this.isImageViewer = true;
      this.imageViewerUrl = url;
      console.log(this.imageViewerUrl);
    },

    async getChannelById(id) {
      this.loader = true;
      try {
        const response = await setupService.getDepositeChannelById(id);
        if (response.status === 200) {
          this.depositeData = response.data.data[0];
          console.log("logo2", response.data.data[0].bank_logo);
          this.imageData.bankLogourl = response.data.data[0].bank_logo
            ? response.data.data[0].bank_logo
            : null;
          this.imageData.banklogo = response.data.data[0].bank_logo
            ? {
                name: response.data.data[0].bank_logo?.split("/").pop(),
                value: response.data.data[0].bank_logo,
              }
            : null;

          this.getallLedgersByCountry();
          this.stoploader();
        }
        console.log("countryOptions", this.DepositeChannel);
      } catch (e) {
        console.error(e);
        this.stoploader();
        this.DepositeChannel = [];
      }
    },

    submitData() {
      const validate = this.$refs.Addform.validate();
      if (validate) {
        if (this.depositeData.channel_id) {
          this.update(this.channelId);
        } else {
          this.save();
        }
      }
    },

    async save() {
      try {
        this.depositeData.bank_logo = this.depositeData.bank_logo.value;
        const response = await setupService.addDepositeChannel(
          this.depositeData
        );
        if (response.data.status_code === 200) {
          console.log("data", response.data);
          this.showAlertSuccess(response.data.message);
          if (this.depositeData.bank_logo && this.depositeData.bank_logo.name) {
            this.uploadLogo(
              response.data.data[0].channel_id,
              this.depositeData.bank_logo
            );
          } else {
            setTimeout(() => {
              this.$router.push({
                name: "Deposit Channel",
              });
            }, 300);
          }

          console.log(response);
        } else {
          this.showAlertError(response.data.message);
        }
      } catch (error) {
        console.error(error);
      }
    },
    async update(id) {
      try {
        const response = await setupService.updateDepositeChannel(
          id,
          this.depositeData
        );
        if (response.data.status_code === 200) {
          this.showAlertSuccess(response.data.message);
          console.log("data", response.data);
          console.log("hittt", this.depositeData.bank_logo);
          if (this.depositeData.bank_logo && this.depositeData.bank_logo.name) {
            this.uploadLogo(
              response.data.data[0].channel_id,
              this.depositeData.bank_logo
            );
          } else {
            setTimeout(() => {
              this.$router.push({
                name: "Deposit Channel",
              });
            }, 300);
          }
        } else {
          this.showAlertError(response.data.message);
        }
      } catch (error) {
        console.error(error);
      }
    },
    async uploadLogo(id, bank_logo) {
      let fileData = new FormData();
      fileData.append("document", bank_logo);
      try {
        const response = await setupService.uploadBanklogo(id, fileData);
        if (response.data.status_code === 200) {
          setTimeout(() => {
            this.$router.push({
              name: "Deposit Channel",
            });
          }, 300);
          this.showAlertSuccess(response.data.message);

          console.log("Logo Update");
        } else {
          this.showAlertError(response.data.message);
        }
      } catch (error) {
        console.error(error);
      }
    },
    async getcountryList() {
      this.loader = true;
      try {
        const response = await setupService.getCountrysetupList();
        if (response.status === 200) {
          this.countryOptions = response.data.data.map((i) => {
            return { txt: i.name, val: i.iso_alpha3 };
          });
        }
        this.dropdown.country_objs = response.data.data;
        console.log("countryOptions", this.countryOptions);
        this.stoploader();
      } catch (e) {
        console.error(e);
        this.stoploader();
        this.countryOptions = [];
      }
    },
    async getchannelTypes() {
      const code = "CTP";
      try {
        const responseData = await commonService.getparameterdropdowns(code);
        if (responseData.data.status_code === 200) {
          this.channelTypes = responseData.data.data.map((i) => {
            return { txt: i.value, val: i.value_code };
          });
        }

        console.log("channelTypes", responseData);
      } catch (e) {
        console.error(e);
      }
    },
    async getchannelAccTypes() {
      const code = "LAT";
      try {
        const responseData = await commonService.getparameterdropdowns(code);
        if (responseData.data.status_code === 200) {
          this.accountTypes = responseData.data.data.map((i) => {
            return { txt: i.value, val: i.value_code };
          });
        }

        console.log("accountTypes", responseData);
      } catch (e) {
        console.error(e);
      }
    },
    async getallLedgersByCountry() {
      try {
        const responseData = await setupService.getallLedgersByCountry(
          this.depositeData.country
        );
        if (responseData.data.status_code === 200) {
          this.ledgerIds = responseData.data.data.flatMap(
            (item) => item.sub_ledger_list
          );
        }

        console.log("LedgerAccounts", this.ledgerIds);
      } catch (e) {
        console.error(e);
      }
    },
  },
};
</script>

<style scoped lang="scss">
@import "@/global.scss";
.required:after {
  content: " *";
  color: red;
}
</style>
